import styled, { css } from 'styled-components';
import { BreakpointsSizes } from '../../@types/design-system/break-boints';
import Theme from '../../design-system/Theme';
import getModulesType from '../../utils/get-Modules-Types';
import getSubjectsType from '../../utils/get-Subject-Types';

const newTheme = new Theme();
const { mobile, tablet, laptop } = newTheme.breakpoints;

type SubjectProps = {
  $subject: string;
  $color: 10 | 20 | 30 | 40 | 50;
  $classtitlename?: string;
}

type ModuleProps = {
  $module: number;
  $color: 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;
}

export const Header = styled.div`
  border-radius: 20px 20px 0 0;
  position: relative;
  height: auto;

  ${newTheme.respondTo(mobile as BreakpointsSizes, css`
    min-width: 22.3rem;
  `)}

  ${newTheme.respondTo(tablet as BreakpointsSizes, css`
    max-width: 100vw;
  `)}
`;

export const BoxImage = styled.figure`
  max-width: 100%;

  ${newTheme.respondTo(mobile as BreakpointsSizes, css`
    max-height: 17.8125rem;
    img {
      width: 100%;
      height: 17.81rem;
      border-radius: 20px 20px 0 0;
    }
  `)}

  ${newTheme.respondTo(tablet as BreakpointsSizes, css`
    max-height: 21.6rem;
    img {
      width: 100%;
      height: 21.62rem;
      border-radius: 20px 20px 0 0;
    }
  `)}

  ${newTheme.respondTo(laptop as BreakpointsSizes, css`
    max-height: 30.5rem;
    img {
      width: 100%;
      height: 28rem;
      border-radius: 20px 20px 0 0;
      object-fit: cover;

      @media (max-width: 600px){
        height: 285px;
      }
    }
  `)}

  border-radius: 20px 20px 0 0;
  overflow: hidden;
`;

export const BoxTooltip = styled.div`
  display: flex;
  max-width: 380px;
  transform: translateY(-30px);
  position: relative;
  z-index: 1;
`;

const TooltipBaseStyle = css`
    font-weight: 800;
    font-family: "Museo";

    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;

    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;

    padding: 0 32px;

    @media (max-width: 999px){
      height: 44px;
    }
`;

export const TooltipMateria = styled.div<SubjectProps>`
  background: ${({ theme, $subject, $color }) => getSubjectsType({ color: $color, subject: $subject, theme })};

  ${TooltipBaseStyle}
  z-index: 0;
  transform: translateX(-16px);
  color: ${({ theme }) => theme.colors.grayscale[110]};
`;

export const TooltipModulo = styled.div<ModuleProps>`
  background: ${({ theme, $module, $color }) => getModulesType({ modulo: $module, color: $color, theme })};
  ${TooltipBaseStyle}
  z-index: 1;
  color: ${({ theme }) => theme.colors.grayscale[10]};
`;

export const BoxTitle = styled.div<SubjectProps>`
  width: 100%;
  ${({ theme }) => theme.spacing.articleHeader}

  .capitulo {
    ${({ theme }) => theme.typography.h4}
    border-bottom: none;
    color: ${({ theme, $subject, $color }) => getSubjectsType({ theme, subject: $subject, color: $color })};
    padding-bottom: 0;
    margin-bottom: 10px;

    @media (min-width: 600px){
      padding-top: 20px;
    }
  }

  h1 {
    ${({ theme }) => theme.typography.h1}
    margin-bottom: 1.9rem;
    color: ${({ theme }) => theme.colors.grayscale[20]};
  }

  h2 {
    ${({ theme }) => theme.typography.h2}
    color: ${({ theme }) => theme.colors.grayscale[40]};
    margin-bottom: 2.43rem;
  }

  h3 {
    ${({ theme }) => theme.typography.h3}
    color: ${({ theme }) => theme.colors.grayscale[50]};
    margin-bottom: 2.43rem;
    text-align: right;
  }

  h4 {
    ${({ theme }) => theme.typography.h4}
    padding-bottom: 30px;
    border-bottom: 2px solid ${({ theme, $color, $subject }) => getSubjectsType({ theme, color: $color, subject: $subject })};
    color: ${({ theme }) => theme.colors.grayscale[30]};
    ${({ $classtitlename }) => (Number($classtitlename) === 0
    ? css<SubjectProps>`
    border-bottom: 4px solid ${({ theme, $color, $subject }) => getSubjectsType({ theme, color: $color, subject: $subject })};`
    : css<SubjectProps>`
    border-bottom: none;
  `)
};
  }

  .capitulo {
    ${({ theme }) => theme.typography.h4}
    border-bottom: none;
    color: ${({ theme, $subject, $color }) => getSubjectsType({ theme, subject: $subject, color: $color })};
    padding-bottom: 1.87rem;
    margin-bottom: 2.43rem;
  }

  .titulo {
    @media (max-width: 600px){
      font-size: 2.2rem;
      line-height: normal;
    }
  }

  .estrutura {
    margin-bottom: 0;

    @media (max-width: 600px){
      font-size: 26px;
      line-height: normal;
    }
  }

  ${({ $classtitlename }) => (Number($classtitlename) !== 0
    ? css`
      .coopetencia {
        display: none;
      }
      .Desenvolvimento {
        display: block;
        margin-bottom: -290px;
      }
    `
    : css`
      .estrutura {
        display: block;
      }
      .coopetencia {
        display: block;
      }
      .Desenvolvimento {
        display: none;
      }
    `)
}
`;
